export default __webpack_public_path__ + "static/media/benchmark-social.66941549.png";